import React from 'react';
import { motion } from 'framer-motion';

const StatsSection = () => {
  const stats = [
    { number: "100%", label: "Satisfaction" },
    { number: "+122k", label: "Clients" },
    { number: "55k", label: "Properties" },
    { number: "3,587+", label: "Rooms" }
  ];

  const containerVariants = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
  };

  return (
    <section className="py-12 px-6 max-w-7xl mx-auto relative z-10">
      <motion.div 
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        className="grid grid-cols-2 md:grid-cols-4 gap-6"
      >
        {stats.map((stat, index) => (
          <motion.div key={index} variants={itemVariants}>
            <div className="group relative bg-[#1A1F29]/40 backdrop-blur-md border border-white/5 rounded-2xl p-8 flex flex-col items-center justify-center hover:border-white/10 transition-colors duration-300 overflow-hidden">
              
              {/* Subtle hover glow behind the number */}
              <div className="absolute inset-0 bg-electric-green/0 group-hover:bg-electric-green/5 transition-colors duration-500 rounded-2xl" />
              
              <h3 className="text-4xl md:text-5xl font-black text-white mb-2 relative z-10 drop-shadow-md group-hover:text-electric-green transition-colors duration-300">
                {stat.number}
              </h3>
              <p className="text-xs md:text-sm text-gray-400 uppercase tracking-[0.2em] font-medium relative z-10">
                {stat.label}
              </p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default StatsSection;